import React, { useMemo } from 'react';
import { FileIcon, PDFIcon } from 'assets/icons';
import { FallbackImage } from 'components';

interface FileCardProps {
  label: string
  file?: any
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FileCard = ({ label, file, onChange }: FileCardProps) => {
  const { blob, fileName, isPDF } = useMemo(() => {
    if (!file) return {
      blob: null,
      fileName: 'Subir documento',
      isPDF: false,
    };

    const length = String(file?.name || file?.type || file || '').length;
    const isPDF = String(file?.name || file).endsWith('pdf');
    let fileName = String(file?.name || file).substring(length - 16);
    if (fileName === 'null') fileName = '';

    return {
      blob: file instanceof Blob ? URL.createObjectURL(file) : null,
      fileName: fileName ? '...' + fileName : 'Subir documento',
      isPDF,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);

  return (
    <label className="file">
      <label>{ label }</label>
      <div className="file-card">
        <div className="photo-wrapper">
          {!isPDF && (
            <FallbackImage
              key={label + ' ' + fileName}
              src={blob || file}
              placeholder={FileIcon}
              className="file-image"
              placeholderClassName="empty"
              alt={fileName}
            />
          )}
          {!!file && isPDF && (
            <img className="pdf" src={PDFIcon} alt="Documento" />
          )}
        </div>
        <p className="filename">{ fileName }</p>
      </div>
      {onChange && (
        <input type="file" accept="image/*, application/pdf" hidden onChange={onChange} />
      )}
    </label>
  )
}